import type { Guide, GuideRecordHint } from '../types';

/**
 * S-25.10-01 — ręczna archiwizacja prezlecenia z powodem i przywrócenie (decyzja użytkownika 24.10.2026,
 * A6: prezlecenie nie wygasa samo; scenariusz e2e 30). A30O — prezlecenie CS przed akceptacją, A30Z —
 * zarchiwizowane przez CS (`e2e/setup/scenario-state.mjs`). Nagrywarka tylko otwiera pole powodu, niczego
 * nie archiwizuje.
 */
const OPEN: GuideRecordHint = {
  description: 'prezlecenie przed akceptacją — z listy prezleceń',
  listPath: '/pre-orders',
};
const ARCHIVED: GuideRecordHint = {
  description: 'zarchiwizowane prezlecenie — z listy z filtrem „Tylko zarchiwizowane”',
  listPath: '/pre-orders',
  listFilter: { archived: 'only' },
};

export const guide: Guide = {
  flagKey: 'preOrderArchive',
  title: 'Ręczna archiwizacja prezlecenia z powodem i przywrócenie',
  whatItDoes:
    'Prezlecenie nie wygasa samo — CS albo Administracja archiwizuje je ręcznie, z powodem. Zarchiwizowane znika z listy prezleceń, kolejek i pulpitu przyjęcia zleceń, a wiersz w banku schodzi z puli do „Nieaktualne”. Na karcie stoi, kto, kiedy i dlaczego je zarchiwizował; zmienić ani zaakceptować go nie można, dopóki ktoś go nie przywróci — też z powodem. Lista ma filtr „Zarchiwizowane”. Prezlecenia zaakceptowanego (jest już zlecenie z numerem) archiwizować nie można.',
  audience: ['CS', 'Administracja'],
  presentationItems: ['S-25.10-01'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/show',
      record: OPEN,
      target: 'pre-order-archive-actions',
      title: '„Archiwizuj” z powodem',
      description:
        'Pod akcjami prezlecenia przycisk „Archiwizuj” otwiera pole powodu — co najmniej 10 znaków, powód zostaje w historii prezlecenia.',
      action: 'Kliknij „Archiwizuj”, wpisz powód i „Zarchiwizuj”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'a30OpenPreOrderId' },
        actions: [{ kind: 'click', target: 'pre-order-archive' }],
      },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: ARCHIVED,
      target: 'pre-order-archived',
      title: 'Zarchiwizowane — kto, kiedy, dlaczego',
      description:
        'Na karcie zarchiwizowanego prezlecenia baner z datą, autorem i powodem; zmiany i akceptacja są zablokowane, a „Przywróć” (z powodem) przywraca prezlecenie na listy, a wiersz banku do „Prezlecenie”.',
      action: 'Otwórz zarchiwizowane prezlecenie z listy z filtrem „Zarchiwizowane”.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'a30ArchivedPreOrderId' } },
    },
  ],
};
